export default [
  { code: "🏁", label: "Zielflagge 🏁" },
  { code: "🚩", label: "Wimpel 🚩" },
  { code: "🎌", label: "Überkreuzte Flaggen 🎌" },
  { code: "🏴", label: "Schwarze Flagge 🏴" },
  { code: "🏳️", label: "Weiße Flagge 🏳️" },
  { code: "🏳️‍🌈", label: "Regenbogenflagge 🏳️‍🌈" },
  { code: "🏳️‍⚧️", label: "Transgender-Flagge 🏳️‍⚧️" },
  { code: "🏴‍☠️", label: "Piratenflagge 🏴‍☠️" },
  { code: "🇺🇳", label: "Flag: United Nations 🇺🇳" },
  { code: "🇦🇴", label: "Angola 🇦🇴" },
  { code: "🇧🇫", label: "Burkina Faso 🇧🇫" },
  { code: "🇧🇮", label: "Burundi 🇧🇮" },
  { code: "🇧🇯", label: "Benin 🇧🇯" },
  { code: "🇧🇼", label: "Botsuana 🇧🇼" },
  { code: "🇨🇩", label: "Kongo-Kinshasa 🇨🇩" },
  { code: "🇨🇫", label: "Zentralafrikanische Republik 🇨🇫" },
  { code: "🇨🇬", label: "Kongo-Brazzaville 🇨🇬" },
  { code: "🇨🇮", label: "Côte d’Ivoire 🇨🇮" },
  { code: "🇨🇲", label: "Kamerun 🇨🇲" },
  { code: "🇨🇻", label: "Cabo Verde 🇨🇻" },
  { code: "🇩🇯", label: "Dschibuti 🇩🇯" },
  { code: "🇩🇿", label: "Algerien 🇩🇿" },
  { code: "🇪🇬", label: "Ägypten 🇪🇬" },
  { code: "🇪🇭", label: "Westsahara 🇪🇭" },
  { code: "🇪🇷", label: "Eritrea 🇪🇷" },
  { code: "🇪🇹", label: "Äthiopien 🇪🇹" },
  { code: "🇬🇦", label: "Gabun 🇬🇦" },
  { code: "🇬🇭", label: "Ghana 🇬🇭" },
  { code: "🇬🇲", label: "Gambia 🇬🇲" },
  { code: "🇬🇳", label: "Guinea 🇬🇳" },
  { code: "🇬🇶", label: "Äquatorialguinea 🇬🇶" },
  { code: "🇬🇼", label: "Guinea-Bissau 🇬🇼" },
  { code: "🇰🇪", label: "Kenia 🇰🇪" },
  { code: "🇰🇲", label: "Komoren 🇰🇲" },
  { code: "🇱🇷", label: "Liberia 🇱🇷" },
  { code: "🇱🇸", label: "Lesotho 🇱🇸" },
  { code: "🇱🇾", label: "Libyen 🇱🇾" },
  { code: "🇲🇦", label: "Marokko 🇲🇦" },
  { code: "🇲🇬", label: "Madagaskar 🇲🇬" },
  { code: "🇲🇱", label: "Mali 🇲🇱" },
  { code: "🇲🇷", label: "Mauretanien 🇲🇷" },
  { code: "🇲🇺", label: "Mauritius 🇲🇺" },
  { code: "🇲🇼", label: "Malawi 🇲🇼" },
  { code: "🇲🇿", label: "Mosambik 🇲🇿" },
  { code: "🇳🇦", label: "Namibia 🇳🇦" },
  { code: "🇳🇪", label: "Niger 🇳🇪" },
  { code: "🇳🇬", label: "Nigeria 🇳🇬" },
  { code: "🇷🇼", label: "Ruanda 🇷🇼" },
  { code: "🇸🇨", label: "Seychellen 🇸🇨" },
  { code: "🇸🇩", label: "Sudan 🇸🇩" },
  { code: "🇸🇱", label: "Sierra Leone 🇸🇱" },
  { code: "🇸🇳", label: "Senegal 🇸🇳" },
  { code: "🇸🇴", label: "Somalia 🇸🇴" },
  { code: "🇸🇸", label: "Südsudan 🇸🇸" },
  { code: "🇸🇿", label: "Eswatini 🇸🇿" },
  { code: "🇹🇩", label: "Tschad 🇹🇩" },
  { code: "🇹🇬", label: "Togo 🇹🇬" },
  { code: "🇹🇳", label: "Tunesien 🇹🇳" },
  { code: "🇹🇿", label: "Tansania 🇹🇿" },
  { code: "🇺🇬", label: "Uganda 🇺🇬" },
  { code: "🇿🇦", label: "Südafrika 🇿🇦" },
  { code: "🇿🇲", label: "Sambia 🇿🇲" },
  { code: "🇿🇼", label: "Simbabwe 🇿🇼" },
  { code: "🇦🇬", label: "Antigua und Barbuda 🇦🇬" },
  { code: "🇦🇮", label: "Anguilla 🇦🇮" },
  { code: "🇦🇷", label: "Argentinien 🇦🇷" },
  { code: "🇦🇼", label: "Aruba 🇦🇼" },
  { code: "🇧🇧", label: "Barbados 🇧🇧" },
  { code: "🇧🇱", label: "St. Barthélemy 🇧🇱" },
  { code: "🇧🇲", label: "Bermuda 🇧🇲" },
  { code: "🇧🇴", label: "Bolivien 🇧🇴" },
  { code: "🇧🇶", label: "Karibische Niederlande 🇧🇶" },
  { code: "🇧🇷", label: "Brasilien 🇧🇷" },
  { code: "🇧🇸", label: "Bahamas 🇧🇸" },
  { code: "🇧🇿", label: "Belize 🇧🇿" },
  { code: "🇨🇦", label: "Kanada 🇨🇦" },
  { code: "🇨🇱", label: "Chile 🇨🇱" },
  { code: "🇨🇴", label: "Kolumbien 🇨🇴" },
  { code: "🇨🇷", label: "Costa Rica 🇨🇷" },
  { code: "🇨🇺", label: "Kuba 🇨🇺" },
  { code: "🇨🇼", label: "Curaçao 🇨🇼" },
  { code: "🇩🇲", label: "Dominica 🇩🇲" },
  { code: "🇩🇴", label: "Dominikanische Republik 🇩🇴" },
  { code: "🇪🇨", label: "Ecuador 🇪🇨" },
  { code: "🇫🇰", label: "Falklandinseln 🇫🇰" },
  { code: "🇬🇩", label: "Grenada 🇬🇩" },
  { code: "🇬🇫", label: "Französisch-Guayana 🇬🇫" },
  { code: "🇬🇵", label: "Guadeloupe 🇬🇵" },
  { code: "🇬🇹", label: "Guatemala 🇬🇹" },
  { code: "🇬🇾", label: "Guyana 🇬🇾" },
  { code: "🇭🇳", label: "Honduras 🇭🇳" },
  { code: "🇭🇹", label: "Haiti 🇭🇹" },
  { code: "🇯🇲", label: "Jamaika 🇯🇲" },
  { code: "🇰🇳", label: "St. Kitts und Nevis 🇰🇳" },
  { code: "🇰🇾", label: "Kaimaninseln 🇰🇾" },
  { code: "🇱🇨", label: "St. Lucia 🇱🇨" },
  { code: "🇲🇫", label: "St. Martin 🇲🇫" },
  { code: "🇲🇶", label: "Martinique 🇲🇶" },
  { code: "🇲🇸", label: "Montserrat 🇲🇸" },
  { code: "🇲🇽", label: "Mexiko 🇲🇽" },
  { code: "🇳🇮", label: "Nicaragua 🇳🇮" },
  { code: "🇵🇦", label: "Panama 🇵🇦" },
  { code: "🇵🇪", label: "Peru 🇵🇪" },
  { code: "🇵🇲", label: "St. Pierre und Miquelon 🇵🇲" },
  { code: "🇵🇷", label: "Puerto Rico 🇵🇷" },
  { code: "🇵🇾", label: "Paraguay 🇵🇾" },
  { code: "🇸🇷", label: "Suriname 🇸🇷" },
  { code: "🇸🇻", label: "El Salvador 🇸🇻" },
  { code: "🇸🇽", label: "Sint Maarten 🇸🇽" },
  { code: "🇹🇨", label: "Turks- und Caicosinseln 🇹🇨" },
  { code: "🇹🇹", label: "Trinidad und Tobago 🇹🇹" },
  { code: "🇺🇸", label: "Vereinigte Staaten 🇺🇸" },
  { code: "🇺🇾", label: "Uruguay 🇺🇾" },
  { code: "🇻🇪", label: "Venezuela 🇻🇪" },
  { code: "🇻🇬", label: "Britische Jungferninseln 🇻🇬" },
  { code: "🇻🇮", label: "Amerikanische Jungferninseln 🇻🇮" },
  { code: "🇦🇪", label: "Vereinigte Arabische Emirate 🇦🇪" },
  { code: "🇦🇫", label: "Afghanistan 🇦🇫" },
  { code: "🇦🇿", label: "Aserbaidschan 🇦🇿" },
  { code: "🇧🇩", label: "Bangladesch 🇧🇩" },
  { code: "🇧🇭", label: "Bahrain 🇧🇭" },
  { code: "🇧🇳", label: "Brunei Darussalam 🇧🇳" },
  { code: "🇧🇹", label: "Bhutan 🇧🇹" },
  { code: "🇨🇳", label: "China 🇨🇳" },
  { code: "🇭🇰", label: "Sonderverwaltungsregion Hongkong 🇭🇰" },
  { code: "🇮🇩", label: "Indonesien 🇮🇩" },
  { code: "🇮🇱", label: "Israel 🇮🇱" },
  { code: "🇮🇳", label: "Indien 🇮🇳" },
  { code: "🇮🇶", label: "Irak 🇮🇶" },
  { code: "🇮🇷", label: "Iran 🇮🇷" },
  { code: "🇯🇴", label: "Jordanien 🇯🇴" },
  { code: "🇯🇵", label: "Japan 🇯🇵" },
  { code: "🇰🇬", label: "Kirgisistan 🇰🇬" },
  { code: "🇰🇭", label: "Kambodscha 🇰🇭" },
  { code: "🇰🇵", label: "Nordkorea 🇰🇵" },
  { code: "🇰🇷", label: "Südkorea 🇰🇷" },
  { code: "🇰🇼", label: "Kuwait 🇰🇼" },
  { code: "🇰🇿", label: "Kasachstan 🇰🇿" },
  { code: "🇱🇦", label: "Laos 🇱🇦" },
  { code: "🇱🇧", label: "Libanon 🇱🇧" },
  { code: "🇱🇰", label: "Sri Lanka 🇱🇰" },
  { code: "🇲🇲", label: "Myanmar 🇲🇲" },
  { code: "🇲🇳", label: "Mongolei 🇲🇳" },
  { code: "🇲🇴", label: "Sonderverwaltungsregion Macau 🇲🇴" },
  { code: "🇲🇻", label: "Malediven 🇲🇻" },
  { code: "🇲🇾", label: "Malaysia 🇲🇾" },
  { code: "🇳🇵", label: "Nepal 🇳🇵" },
  { code: "🇴🇲", label: "Oman 🇴🇲" },
  { code: "🇵🇭", label: "Philippinen 🇵🇭" },
  { code: "🇵🇰", label: "Pakistan 🇵🇰" },
  { code: "🇵🇸", label: "Palästinensische Autonomiegebiete 🇵🇸" },
  { code: "🇶🇦", label: "Katar 🇶🇦" },
  { code: "🇸🇦", label: "Saudi-Arabien 🇸🇦" },
  { code: "🇸🇬", label: "Singapur 🇸🇬" },
  { code: "🇸🇾", label: "Syrien 🇸🇾" },
  { code: "🇹🇭", label: "Thailand 🇹🇭" },
  { code: "🇹🇯", label: "Tadschikistan 🇹🇯" },
  { code: "🇹🇱", label: "Timor-Leste 🇹🇱" },
  { code: "🇹🇲", label: "Turkmenistan 🇹🇲" },
  { code: "🇹🇷", label: "Türkei 🇹🇷" },
  { code: "🇹🇼", label: "Taiwan 🇹🇼" },
  { code: "🇺🇿", label: "Usbekistan 🇺🇿" },
  { code: "🇻🇳", label: "Vietnam 🇻🇳" },
  { code: "🇾🇪", label: "Jemen 🇾🇪" },
  { code: "🇦🇩", label: "Andorra 🇦🇩" },
  { code: "🇦🇱", label: "Albanien 🇦🇱" },
  { code: "🇦🇲", label: "Armenien 🇦🇲" },
  { code: "🇦🇹", label: "Österreich 🇦🇹" },
  { code: "🇧🇦", label: "Bosnien und Herzegowina 🇧🇦" },
  { code: "🇧🇪", label: "Belgien 🇧🇪" },
  { code: "🇧🇬", label: "Bulgarien 🇧🇬" },
  { code: "🇧🇾", label: "Belarus 🇧🇾" },
  { code: "🇨🇭", label: "Schweiz 🇨🇭" },
  { code: "🇨🇾", label: "Zypern 🇨🇾" },
  { code: "🇨🇿", label: "Tschechien 🇨🇿" },
  { code: "🇩🇪", label: "Deutschland 🇩🇪" },
  { code: "🇩🇰", label: "Dänemark 🇩🇰" },
  { code: "🇪🇦", label: "Ceuta und Melilla 🇪🇦" },
  { code: "🇪🇪", label: "Estland 🇪🇪" },
  { code: "🇪🇸", label: "Spanien 🇪🇸" },
  { code: "🇪🇺", label: "Flag: European Union 🇪🇺" },
  { code: "🇫🇮", label: "Finnland 🇫🇮" },
  { code: "🇫🇷", label: "Frankreich 🇫🇷" },
  { code: "🇬🇧", label: "Vereinigtes Königreich 🇬🇧" },
  { code: "🇬🇪", label: "Georgien 🇬🇪" },
  { code: "🇬🇬", label: "Guernsey 🇬🇬" },
  { code: "🇬🇮", label: "Gibraltar 🇬🇮" },
  { code: "🇬🇷", label: "Griechenland 🇬🇷" },
  { code: "🇭🇷", label: "Kroatien 🇭🇷" },
  { code: "🇭🇺", label: "Ungarn 🇭🇺" },
  { code: "🇮🇪", label: "Irland 🇮🇪" },
  { code: "🇮🇲", label: "Isle of Man 🇮🇲" },
  { code: "🇮🇸", label: "Island 🇮🇸" },
  { code: "🇮🇹", label: "Italien 🇮🇹" },
  { code: "🇯🇪", label: "Jersey 🇯🇪" },
  { code: "🇱🇮", label: "Liechtenstein 🇱🇮" },
  { code: "🇱🇹", label: "Litauen 🇱🇹" },
  { code: "🇱🇺", label: "Luxemburg 🇱🇺" },
  { code: "🇱🇻", label: "Lettland 🇱🇻" },
  { code: "🇲🇨", label: "Monaco 🇲🇨" },
  { code: "🇲🇩", label: "Republik Moldau 🇲🇩" },
  { code: "🇲🇪", label: "Montenegro 🇲🇪" },
  { code: "🇲🇰", label: "Nordmazedonien 🇲🇰" },
  { code: "🇲🇹", label: "Malta 🇲🇹" },
  { code: "🇳🇱", label: "Niederlande 🇳🇱" },
  { code: "🇳🇴", label: "Norwegen 🇳🇴" },
  { code: "🇵🇱", label: "Polen 🇵🇱" },
  { code: "🇵🇹", label: "Portugal 🇵🇹" },
  { code: "🇷🇴", label: "Rumänien 🇷🇴" },
  { code: "🇷🇸", label: "Serbien 🇷🇸" },
  { code: "🇷🇺", label: "Russland 🇷🇺" },
  { code: "🇸🇪", label: "Schweden 🇸🇪" },
  { code: "🇸🇮", label: "Slowenien 🇸🇮" },
  { code: "🇸🇰", label: "Slowakei 🇸🇰" },
  { code: "🇸🇲", label: "San Marino 🇸🇲" },
  { code: "🇺🇦", label: "Ukraine 🇺🇦" },
  { code: "🇻🇦", label: "Vatikanstadt 🇻🇦" },
  { code: "🇽🇰", label: "Kosovo 🇽🇰" },
  { code: "🏴󠁧󠁢󠁥󠁮󠁧󠁿", label: "England 🏴󠁧󠁢󠁥󠁮󠁧󠁿" },
  { code: "🏴󠁧󠁢󠁳󠁣󠁴󠁿", label: "Schottland 🏴󠁧󠁢󠁳󠁣󠁴󠁿" },
  { code: "🏴󠁧󠁢󠁷󠁬󠁳󠁿", label: "Wales 🏴󠁧󠁢󠁷󠁬󠁳󠁿" },
  { code: "🇦🇨", label: "Ascension 🇦🇨" },
  { code: "🇦🇶", label: "Antarktis 🇦🇶" },
  { code: "🇦🇸", label: "Amerikanisch-Samoa 🇦🇸" },
  { code: "🇦🇺", label: "Australien 🇦🇺" },
  { code: "🇦🇽", label: "Ålandinseln 🇦🇽" },
  { code: "🇧🇻", label: "Bouvetinsel 🇧🇻" },
  { code: "🇨🇨", label: "Kokosinseln 🇨🇨" },
  { code: "🇨🇰", label: "Cookinseln 🇨🇰" },
  { code: "🇨🇵", label: "Clipperton-Insel 🇨🇵" },
  { code: "🇨🇽", label: "Weihnachtsinsel 🇨🇽" },
  { code: "🇩🇬", label: "Diego Garcia 🇩🇬" },
  { code: "🇫🇯", label: "Fidschi 🇫🇯" },
  { code: "🇫🇲", label: "Mikronesien 🇫🇲" },
  { code: "🇬🇱", label: "Grönland 🇬🇱" },
  { code: "🇬🇸", label: "Südgeorgien und die Südlichen Sandwichinseln 🇬🇸" },
  { code: "🇬🇺", label: "Guam 🇬🇺" },
  { code: "🇭🇲", label: "Heard und McDonaldinseln 🇭🇲" },
  { code: "🇮🇨", label: "Kanarische Inseln 🇮🇨" },
  { code: "🇮🇴", label: "Britisches Territorium im Indischen Ozean 🇮🇴" },
  { code: "🇰🇮", label: "Kiribati 🇰🇮" },
  { code: "🇲🇭", label: "Marshallinseln 🇲🇭" },
  { code: "🇲🇵", label: "Nördliche Marianen 🇲🇵" },
  { code: "🇳🇨", label: "Neukaledonien 🇳🇨" },
  { code: "🇳🇫", label: "Norfolkinsel 🇳🇫" },
  { code: "🇳🇷", label: "Nauru 🇳🇷" },
  { code: "🇳🇺", label: "Niue 🇳🇺" },
  { code: "🇳🇿", label: "Neuseeland 🇳🇿" },
  { code: "🇵🇫", label: "Französisch-Polynesien 🇵🇫" },
  { code: "🇵🇬", label: "Papua-Neuguinea 🇵🇬" },
  { code: "🇵🇳", label: "Pitcairninseln 🇵🇳" },
  { code: "🇵🇼", label: "Palau 🇵🇼" },
  { code: "🇷🇪", label: "Réunion 🇷🇪" },
  { code: "🇸🇧", label: "Salomonen 🇸🇧" },
  { code: "🇸🇭", label: "St. Helena 🇸🇭" },
  { code: "🇸🇯", label: "Spitzbergen und Jan Mayen 🇸🇯" },
  { code: "🇸🇹", label: "São Tomé und Príncipe 🇸🇹" },
  { code: "🇹🇦", label: "Tristan da Cunha 🇹🇦" },
  { code: "🇹🇫", label: "Französische Süd- und Antarktisgebiete 🇹🇫" },
  { code: "🇹🇰", label: "Tokelau 🇹🇰" },
  { code: "🇹🇴", label: "Tonga 🇹🇴" },
  { code: "🇹🇻", label: "Tuvalu 🇹🇻" },
  { code: "🇺🇲", label: "Amerikanische Überseeinseln 🇺🇲" },
  { code: "🇻🇨", label: "St. Vincent und die Grenadinen 🇻🇨" },
  { code: "🇻🇺", label: "Vanuatu 🇻🇺" },
  { code: "🇼🇫", label: "Wallis und Futuna 🇼🇫" },
  { code: "🇼🇸", label: "Samoa 🇼🇸" },
  { code: "🇾🇹", label: "Mayotte 🇾🇹" }
];
